import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { FadeAnimation } from '@app/core/animations/fade.transition';
import { GlobalFiltersState } from '@app/core/store/states/global-filters/global-filters.state';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { map, Observable } from 'rxjs';
import { SelectorTranslationTexts } from '../../models/selector.model';
import { AdGroupSelectorService } from '../../services/ad-group-selector.service';
import { BaseGlobalSelectorComponent } from '../base-global-selector/base-global-selector.component';

@Component({
  standalone: false,
  selector: 'adspt-ad-group-selector',
  templateUrl: './ad-group-selector.component.html',
  styleUrls: ['./ad-group-selector.component.scss'],
  animations: [FadeAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AdGroupSelectorService],
})
export class AdGroupSelectorComponent extends BaseGlobalSelectorComponent {
  heapInfo = {
    search: 'ad-groups-global-search',
    switch: 'ad-groups-global-filter-switch',
    item: 'ad-groups-global-select',
    reset: 'ad-groups-global-reset-filter',
    apply: 'ad-groups-global-apply-filter',
  };
  translations$: Observable<SelectorTranslationTexts> = this.translate.get('global-filter.adgroup-selector').pipe(
    map((values) => ({
      title: values.placeholder,
      search: values.search,
      all: values.all,
      selected: values.selected,
      notSelectable: values['not-selectable'],
      applyTooltip: values['apply-filters-tooltip'],
    })),
  );
  hasSrcQuery$ = this.store.select(GlobalFiltersState.hasAdGroupQuery);
  hasDestQuery$ = this.store.select(GlobalFiltersState.hasDestAdGroupQuery);

  constructor(
    private store: Store,
    service: AdGroupSelectorService,
    translate: TranslateService,
    cd: ChangeDetectorRef,
  ) {
    super(service, translate, cd);
  }
}
